import { atom } from "recoil";

const userLoggedAtom = atom({
	key: "userLoggedAtom",
	default: JSON.parse(localStorage.getItem("user-logged")),
});

export default userLoggedAtom;
